export default "__VITE_ASSET__DtIhZE9R__"